import { EncryptStorage } from "encrypt-storage";

export const secureLocalStorage = new EncryptStorage(
  process.env.VUE_APP_SECURE_STORAGE_KEY,
  {
    encAlgorithm: "Rabbit",
    prefix: process.env.VUE_APP_NAME,
  }
);
